import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const BasicCheckboxContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 16px;
  margin-left: 16px;

  .ant-checkbox-wrapper {
    color: ${COLORS.TEXT_HIGH};
    font-size: ${FONT.F_SM};
    
    &:hover {
      .ant-checkbox-inner {
        border-color: ${COLORS.PRIMARY};
      }
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${COLORS.PRIMARY};
    border-color: ${COLORS.PRIMARY};
  }
`

export const StyledCheckboxContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  .checkbox-wrapper {
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GREY_T_90};
    border-radius: 8px;
    padding: 8px 16px;
    cursor: pointer;
    min-width: 150px;

    .ant-checkbox-wrapper {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      color: #4D566E;
      user-select: none;
    }
  }
`
